// src/utils/csv.js
// ─────────────────────────────────────────────────────────────
// Export CSV commun à toutes les interfaces de l'administration.
// Même format que l'administration Play & Learn :
//   • séparateur « ; » (Excel en français) ;
//   • UTF-8 avec BOM : les accents s'affichent correctement dans Excel ;
//   • cellules contenant ; " ou un retour à la ligne entourées de guillemets.
// ─────────────────────────────────────────────────────────────

/** 3725 → "1 h 02 min 05 s" */
export const formatDuree = (secondes) => {
  const t = Math.max(0, Math.round(Number(secondes) || 0))
  const h = Math.floor(t / 3600)
  const m = Math.floor((t % 3600) / 60)
  const sec = t % 60
  const p2 = (n) => String(n).padStart(2, "0")
  if (h > 0) return `${h} h ${p2(m)} min ${p2(sec)} s`
  if (m > 0) return `${m} min ${p2(sec)} s`
  return `${sec} s`
}

/**
 * "2026-09-26 18:05:00" ou "2026-09-26T18:05:00" → "26/09/2026 18:05"
 * "2026-09-26" → "26/09/2026"
 */
export const formatDate = (d) => {
  if (!d || typeof d !== "string") return ""
  const [jour, heure] = d.replace("T", " ").split(" ")
  const [a, m, j] = jour.split("-")
  if (!a || !m || !j) return d
  return `${j}/${m}/${a}` + (heure ? " " + heure.slice(0, 5) : "")
}

/** Cellule CSV sûre pour Excel (séparateur ;). Les blancs autour sont retirés
 *  (campus et groupe valent " " quand ils ne sont pas renseignés). */
export const celluleCSV = (v) => {
  let t = v === null || v === undefined ? "" : String(v).trim()
  // Texte commençant par = + - @ : Excel l'exécuterait comme une formule
  // (pseudo « =HYPERLINK(…) » saisi dans l'app). Une apostrophe devant le
  // neutralise ; les vrais nombres ne sont pas concernés.
  if (typeof v === "string" && /^[=+\-@\t\r]/.test(t)) t = "'" + t
  return /[;"\n\r]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t
}

/** Nom de fichier sans accents ni caractères refusés par Windows : certains
 *  navigateurs ignorent un nom accentué et enregistrent un fichier « download ». */
export const nomFichier = (nom) => String(nom)
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[\\/:*?"<>|]/g, "-")

export const telechargerCSV = (fichier, entetes, lignes) => {
  const contenu = [
    entetes.map(celluleCSV).join(";"),
    ...lignes.map(l => l.map(celluleCSV).join(";"))
  ].join("\n")
  const blob = new Blob(["\uFEFF" + contenu], { type: "text/csv;charset=utf-8;" })
  const lien = document.createElement("a")
  const url = URL.createObjectURL(blob)
  lien.setAttribute("href", url)
  lien.setAttribute("download", nomFichier(fichier))
  document.body.appendChild(lien)
  lien.click()
  document.body.removeChild(lien)
  // Libération différée : révoquée tout de suite, l'adresse du fichier peut
  // disparaître avant que le navigateur ait lancé le téléchargement (fichier
  // nommé « download » ou téléchargement annulé selon les navigateurs).
  setTimeout(() => URL.revokeObjectURL(url), 10000)
}

/** Date du jour au format AAAA-MM-JJ, pour nommer les fichiers. */
export const aujourdhui = () => {
  const d = new Date()
  const p2 = (n) => String(n).padStart(2, "0")
  return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`
}
